import React, { useState, useEffect, useContext, Button } from "react";

const Buttonlock = ({ list }) => {
  //console.log(datalist);
  return (
    <>
      {list &&
        list.length > 0 &&
        list.map((item, index) => {
          
          return (
            <button
              key={index}
              type="button"
              className="btn btn-success  "
              style={{
                borderWidth: 1,
                alignItems: "center",
                justifyContent: "center",
                width: 37,
                height: 37,
                borderRadius: 80,
              }}
            >
              {item.number}
            </button>
          );
        })}
    </>
  );
};

export default Buttonlock;
